module.exports = __webpack_public_path__ + "img/1548104162.647d92ef.jpg";